import {get} from "lodash"

export const activityThreadRef = (state) => state.dialog.activity.data.threadRef

export const isViewCompanyDialogVisible = state => state.dialogs.viewCompany.isVisible
export const getViewCompanyDialogCompany = state => state.dialogs.viewCompany.company
export const getViewCompanyDialogCompanyId = state => get(state, 'dialogs.viewCompany.company.id')
export const getViewCompanyDialogContact = state => state.dialogs.viewCompany.contact
export const getViewCompanyDialogCurrentFolder = state => state.dialogs.viewCompany.currentFolder
export const getViewCompanyDialogDocuments = state => state.dialogs.viewCompany.documents.data.data

export const getSetupJobCardDialog = state => state.dialogs.setupJobCard

export const getViewJobCardDialog = state => state.dialogs.viewJobCard
export const getViewJobCardDocuments = state => state.dialogs.viewJobCard.pivotTable.data.data

export const getDeliveryNoteDialog = state => state.dialogs.deliveryNote

export const getAddItemsToPurchaseOrderDialog = state => state.dialogs.addItemsToPurchaseOrder

export const getOpportunityDialog = state => state.dialogs.opportunity

export const getPurchaseOrderDialog = state => state.dialogs.purchaseOrder

export const getPurchaseInvoiceDialog = state => state.dialogs.purchaseInvoice

export const getPurchaseOrderMarkPaidDialog = state => state.dialogs.purchaseOrderMarkPaid

export const getPostContactListDialog = state => state.dialogs.postContactList

export const getPostContactDialog = state => state.dialogs.postContact

export const getAddApprovalDialog = state => state.dialogs.addApproval

export const getAddQuoteDialog = state => state.dialogs.addQuote

export const getPrintTemplateDialog = state => state.dialogs.printTemplate

export const isSendCopyEnabled = state => state.dialogs.sendEmailDialog.isSendCopyEnabled
export const getQuotingEmailFromName = state => state.dialogs.sendEmailDialog.quotingEmailFromName
export const getQuotingEmailReplyTo = state => state.dialogs.sendEmailDialog.quotingEmailReplyTo
export const getPurchasingEmailFromName = state => state.dialogs.sendEmailDialog.purchasingEmailFromName
export const getPurchasingEmailReplyTo = state => state.dialogs.sendEmailDialog.purchasingEmailReplyTo
export const getDeliveriesEmailFromName = state => state.dialogs.sendEmailDialog.deliveriesEmailFromName
export const getDeliveriesEmailReplyTo = state => state.dialogs.sendEmailDialog.deliveriesEmailReplyTo
export const getInvoicingEmailFromName = state => state.dialogs.sendEmailDialog.invoicingEmailFromName
export const getInvoicingEmailReplyTo = state => state.dialogs.sendEmailDialog.invoicingEmailReplyTo

export const getAddUserDialog = state => state.dialogs.addUserDialog

export const getAddExternalUserDialog = state => state.dialogs.addExternalUserDialog

export const getChartDialog = state => state.dialogs.chartDialog

export const getDeliveryDialog = state => state.dialogs.delivery
export const isDeliveryDialogVisible = state => get(getDeliveryDialog(state), 'visible', false)
export const isDeliveryDialogDeliveryNew = state => get(getDeliveryDialog(state), 'data.isDeliveryNew', true)
export const getDeliveryDialogDeliveryData = state => get(getDeliveryDialog(state), 'data.delivery')

export const getDeliveryTypeNoteDialog = state => state.dialogs.deliveryTypeNoteDialog
export const getDeliveryActualTimesDialog = state => state.dialogs.deliveryActualTimesDialog

export const isEmailApprovalDialogVisible = state => state.dialogs.emailApprovalDialog.visible

export const getAddBulkInvoicesDialog = state => state.dialogs.addBulkInvoices

export const isDeletePartsPromptVisible = state => get(state, 'dialogs.deletePartsPrompt.visible', false)
export const getDeletePartsPromptPartIds = state => get(state, 'dialogs.deletePartsPrompt.data')

export const getPartUsedInPricingCalculatorPrompt = state => state.dialogs.partUsedInPricingCalculatorPrompt
export const isPartUsedInPricingCalculatorPromptVisible = state =>
  get(getPartUsedInPricingCalculatorPrompt(state), 'visible', false)
export const getPartUsedInPricingCalculatorPromptEntityType = state =>
  get(getPartUsedInPricingCalculatorPrompt(state), 'data')
